import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { setItem } from "../../../utils/storageHelper";

// Action Types
export const SET_USER_CALENDAR_SETTINGS = "SET_USER_CALENDAR_SETTINGS";
export const SAVE_CALENDAR_SETTINGS_ERROR = "SAVE_CALENDAR_SETTINGS_ERROR";
export const GET_USER_CALENDAR_SETTINGS = "LOAD_USER_CALENDAR_SETTINGS";
export const GET_USER_CALENDAR_SETTINGS_ERROR = "LOAD_USER_CALENDAR_SETTINGS_ERROR";

export const calendarViewMap = {
    0: 'Day',
    1: 'Week',
    2: 'Month'
};

export const timeFormatMap = {
    0: 'TwelveHour',
    1: 'TwentyFourHour'
};

export const eventDurationMap = {
    0: 'Minutes15',
    1: 'Minutes20',
    2: 'Minutes30',
    3: 'Minutes45',
    4: 'Minutes55',
    5: 'Hour1',
    6: 'Hour1Minutes30',
    7: 'Hours2'
};

export const weekDayMap = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};

// Default colors for calendar types
export const defaultCalendarColors = {
    globalTasks: '#D5D6FF',
    primary: '#E5F6D1',
    timetable: '#BBE7FC'
};


// Thunk Action Creator
export const saveCalendarSettings = createAsyncThunk(
    "api/User/saveCalendarSettings",
    async (json, { dispatch }) => {
        try {

            const response = await axios.put(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}User/saveCalendarSettings`,
                {
                    // Sent data is already correctly mapped to PascalCase
                    DefaultView: json.defaultView,
                    TimeFormat: json.timeFormat,
                    EventDuration: json.eventDuration,
                    WeekDayStartOn: json.weekDayStartOn,
                    ShowWeekends: json.showWeekends,
                    Colors: json.colors ? {
                        GlobalTasks: json.colors.globalTasks,
                        Primary: json.colors.primary,
                        Timetable: json.colors.timetable
                    } : null
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("The calendar settings have not been saved. No response data detected");
                } else {
                    const calendarSettings = {
                        defaultView: calendarViewMap[response.data.defaultView],
                        timeFormat: timeFormatMap[response.data.timeFormat],
                        eventDuration: eventDurationMap[response.data.eventDuration],
                        weekDayStartOn: weekDayMap[response.data.weekDayStartOn],
                        showWeekends: response.data.showWeekends, // This is already a boolean
                        colors: response.data.colors ? {
                            globalTasks: response.data.colors.globalTasks || defaultCalendarColors.globalTasks,
                            primary: response.data.colors.primary || defaultCalendarColors.primary,
                            timetable: response.data.colors.timetable || defaultCalendarColors.timetable
                        } : null
                    };

                    await setItem(
                        `userCalendarSettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`,
                        JSON.stringify(calendarSettings)
                    );

                    // Dispatch the clean, translated object to the reducer.
                    dispatch({
                        type: SET_USER_CALENDAR_SETTINGS,
                        payload: calendarSettings,
                    });
                }
            }
            else {
                throw new Error("Error saving user settings");
            }
        }
        catch (error) {
            dispatch({ type: SAVE_CALENDAR_SETTINGS_ERROR, payload: error });
        }
    }
);